import React, { useEffect } from "react";

export const FxLabel = props => {

  const { attr } = props;
  const inputType = props.inputType === undefined ? "" : props.inputType;

  // console.log('*** FxLabel ***', attr);

  return (
    <label className={"FxLabel" + inputType + (attr.isNullable() ? "" : " NotNull")} >{attr.attrUiTxt}</label>
  );

}

export const FxLabelBase = props => {

  const { className, nullable, width } = props;
  const sx = {};
  if (width) {
    sx.minWidth = width;
    sx.width = width;
  }

  // console.log('*** FxLabel ***', attr);

  return (
    <label className={(className ? className : "FxLabel") + (nullable ? "" : " NotNull")} style={sx} >{props.children}</label>
  );

}
